// TableData.jsx
import axios from "axios";
import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  FaPlay,
  FaEdit,
  FaSave,
  FaEye,
  FaTimes,
  FaBook,
  FaInfoCircle,
  FaTrash,
  FaSort,
  FaSortUp,
  FaSortDown,
} from "react-icons/fa";
import "./TableData.css";
// import dayjs from "dayjs"
import YouTubePlayer from "./YouTubePlayer";
import {
  Alert,
  Backdrop,
  // AccordionDetails,
  // AccordionSummary,
  Box,
  CircularProgress,
  Dialog,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  // Typography,
  // Grid,
  // TextField,
} from "@mui/material";
import ExpandMoreOutlined from "@mui/icons-material/ExpandMoreOutlined";

import DatePicker from "react-datepicker";
import MuiAlert from "@mui/material/Alert";
import "react-datepicker/dist/react-datepicker.css";
import VideoRecorder from "../common/VideoRecorder";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { usePreference } from "../context/UserContext";
import PayPalModal from "../components/paypal/PaypalModel";
import QuizzesModel from "../common/QuizzesModel";
import ShowCart from "../components/ShowCart";
import AdvertisementModel from "../common/AdvertisementModel";
import QuizSelectionModel from "../components/login/QuizSelectionModel";
// import { Accordion } from "react-bootstrap";
// import { ExpandMoreOutlined } from "@mui/icons-material";

// import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// ----------------- DATE HELPERS + SUBCOMPONENTS -----------------
const toLocalISO = (date) => {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

const fromISO = (iso) => {
  if (!iso) return null;
  const [y, m, d] = String(iso).split("T")[0].split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
};

const DateInput = React.forwardRef(function DateInput(
  { value, onClick, className, placeholder = "YYYY-MM-DD" },
  ref
) {
  return (
    <input
      ref={ref}
      type="text"
      readOnly
      onClick={onClick}
      value={value || ""}
      placeholder={placeholder}
      className={className}
      style={{ cursor: "pointer" }}
    />
  );
});

const RowDateCell = ({
  valueIso,
  minDate,
  focus,
  onChangeIso,
  takenDateSet,
}) => {
  const selfIso = valueIso || "";
  const selected = selfIso ? fromISO(selfIso) : null;

  const isAllowed = (d) => {
    const iso = toLocalISO(d);
    if (selfIso && iso === selfIso) return true; // allow keeping same date
    return !takenDateSet.has(iso); // disable other taken dates
  };

  return (
    <DatePicker
      selected={selected}
      onChange={(d) => onChangeIso(d ? toLocalISO(d) : "")}
      minDate={minDate}
      filterDate={isAllowed}
      dateFormat="yyyy-MM-dd"
      customInput={
        <DateInput className={`date-input ${focus ? "blink" : ""}`} />
      }
      placeholderText="YYYY-MM-DD"
    />
  );
};

const TableData = () => {
  const location = useLocation();
  const { subcategories = [] } = location.state || {};
  const navigate = useNavigate();
  const {
    updateIsLoginOpen,
    updateIsSignUpOpen,
    updateIsNavVisible,
    showCart,
    updateShowCart,
    cart,
    updateCart,
  } = usePreference();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [data, setData] = useState([]);
  const [expandedPacks, setExpandedPacks] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const username = localStorage.getItem("username");
  const userRole = localStorage.getItem("userrole");
  const [openQuizModel, setOpenQuizModel] = useState(false);
  const [catId, setCatId] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [isCollectionId, setIsCollectionId] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [amount, setAmount] = useState(1);
  const [filteredCart, setFilteredCart] = useState([]);
  const [showPaypalModel, setShowPaypalModel] = useState(false);
  const [pack, setPack] = useState({});
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const scrollContainerRefs = useRef({});
  const [editingCell, setEditingCell] = useState({});
  const [blinkCell, setBlinkCell] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [videoUrl, setVideoUrl] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [focusCell, setFocusCell] = useState({ rowIndex: null, column: null });
  const cellRefs = useRef({});
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState({
    audio: 0,
    video: 0,
    videoV: 0,
  });
  const [wordLogs, setWordLogs] = useState([]);
  const [showLogsPopup, setShowLogsPopup] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // success, error, warning, info
  const [editingImage, setEditingImage] = useState({ url: "", rowIndex: null });
  const [updatedValues, setupdatedValues] = useState({});
  const [editingVideo, setEditingVideo] = useState({
    url: "",
    rowIndex: null,
    column: "",
    word: "",
  });
  const [editingAudio, setEditingAudio] = useState({
    url: "",
    rowIndex: null,
    word: "",
  });
  const audioRef = useRef(null);
  const rowsPerPage = 10;

  const API_URL = `https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/List`;

  const desiredColumns = [
    "Word",
    "Etym",
    "Defn",
    "Vocabulary",
    // "Quizlevel",
    "Pron",
    "Pos",
    "Image",
    "Audio",
    "Video",
    "VideoV",
    "Date",
    // "Utfascii",
    "Username",
    "Actions",
    "Quiz"
  ];

  // 🔎 Only these columns will be searched (added)
  const SEARCHABLE_COLUMNS = [
    "Word",
    "Etym",
    "Defn",
    "Vocabulary",
    "Pron",
    "Pos",
    "Date",
  ];

  // Debounced search term (added)
  const [debouncedTerm, setDebouncedTerm] = useState("");
  useEffect(() => {
    const t = setTimeout(
      () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
      200
    );
    return () => clearTimeout(t);
  }, [searchTerm]);

  // Reset to page 1 on search change (added)
  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedTerm]);

  const scrollableColumns = ["Etym", "Defn", "Vocabulary"];
  const [originalData, setOriginalData] = useState([]);
  const [updateLoader, setupdateLoader] = useState(false);
  const isMediaColumn = (col) => ["Audio", "Video", "VideoV"].includes(col);
  const isAudioColumn = (col) => col === "Audio";
  const isVideoColumn = (col) => col === "Video" || col === "VideoV";
  const [newRowData, setNewRowData] = useState({
    Word: "",
    Meaning: "",
    Image: "",
    Audio: "",
    Video: "",
    VideoV: "",
    Quizlevel: "",
    Date: "",
    Etym: "",
    Defn: "",
    Vocabulary: "",
    Pron: "",
    Pos: "",
  });
  // 🔹 States
  // const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  // 🔹 Sorting function
  const handleSort = (col) => {
    let direction = "asc";
    if (sortConfig.key === col && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: col, direction });
  };

  // 🔎 Filter (added)
  const searchResults = useMemo(() => {
    if (!debouncedTerm) return data;
    return data.filter((row) =>
      SEARCHABLE_COLUMNS.some((col) =>
        (row[col] ?? "").toString().toLowerCase().includes(debouncedTerm)
      )
    );
  }, [data, debouncedTerm]);

  // ↕️ Sort (added)
  const _sortedAll = useMemo(() => {
    if (!sortConfig.key) return searchResults;
    const arr = [...searchResults];
    const { key, direction } = sortConfig;

    arr.sort((a, b) => {
      const A = a?.[key] ?? "";
      const B = b?.[key] ?? "";
      if (key === "Date") {
        const dA = new Date(A);
        const dB = new Date(B);
        return direction === "asc" ? dA - dB : dB - dA;
      }
      return direction === "asc"
        ? A.toString().localeCompare(B.toString())
        : B.toString().localeCompare(A.toString());
    });

    return arr;
  }, [searchResults, sortConfig]);

  // 📄 Pagination (added)
  const totalPages = Math.max(1, Math.ceil(_sortedAll.length / rowsPerPage));
  const sortedData = useMemo(() => {
    const start = (currentPage - 1) * rowsPerPage;
    return _sortedAll.slice(start, start + rowsPerPage);
  }, [_sortedAll, currentPage, rowsPerPage]);

  // Keep this alias so any code that expects paginatedData still works (added)
  const paginatedData = sortedData;

  useEffect(() => {
    if (focusCell.rowIndex !== null && focusCell.column !== null) {
      const key = `${focusCell.rowIndex}-${focusCell.column}`;
      const ref = cellRefs.current[key];
      if (ref && ref.current) {
        ref.current.focus();
      }
    }
  }, [focusCell]);

  useEffect(() => {
    if (showAddDialog) {
      setNewRowData({
        Word: "",
        Meaning: "",
        Image: "",
        Audio: "",
        Video: "",
        VideoV: "",
        Quizlevel: "",
        Date: "",
        Etym: "",
        Defn: "",
        Vocabulary: "",
        Pron: "",
        Pos: "",
      });
    }
  }, [showAddDialog]);

  useEffect(() => {
    document.head.insertAdjacentHTML(
      "beforeend",
      `<style>@keyframes blink {0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}}</style>`
    );
  }, []);

  useEffect(() => {
    updateIsNavVisible(true);
    const fetchData = async () => {
      setFilteredData([subcategories]);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (cart.length === 0) {
      updateShowCart(false);
    } else {
      const filteredCartData = cart.map((item) => ({
        packId: item.packId,
        price: item.price,
        isCollection: item.isCollection,
        type: item.type === "monthly",
      }));
      setFilteredCart(filteredCartData);
    }
  }, [cart, updateShowCart]);

  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    if (savedCart) updateCart(JSON.parse(savedCart));
  }, [updateCart]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(API_URL)
      .then((response) => {
        setData(response.data);
        setOriginalData(response.data);
      })
      .catch((err) => console.error("API Error:", err.message))
      .finally(() => setLoading(false));
  }, []);

  // ---- Dates already taken in table, as a Set of "yyyy-MM-dd"
  const takenDateSet = useMemo(() => {
    const isos = (data || [])
      .map((r) => (r?.Date ? String(r.Date).split("T")[0] : ""))
      .filter(Boolean);
    return new Set(isos);
  }, [data]);

  const validateNewWordData = (data) => {
    if (!data.Word || data.Word.trim() === "") {
      return "Word is required.";
    }
    if (!data.Etym || data.Etym.trim() === "") {
      return "Etymology is required.";
    }
    if (!data.Defn || data.Defn.trim() === "") {
      return "Definition is required.";
    }
    if (!data.Vocabulary || data.Vocabulary.trim() === "") {
      return "Vocabulary is required.";
    }
    if (!data.Pron || data.Pron.trim() === "") {
      return "Pronunciation is required.";
    }
    if (!data.Pos || data.Pos.trim() === "") {
      return "Parts of Speech (Pos) is required.";
    }

    // if (!data.Quizlevel || data.Quizlevel.toString().trim() === "") {
    //   return "Quiz Level is required.";
    // }
    if (!data.Date || data.Date.trim() === "") {
      return "Date is required.";
    }
    return null;
  };

  const handleChange = (e, rowIndex, column) => {
    const updatedValue =
      e.target?.value ?? e.target?.innerText ?? e?.target?.textContent;

    setData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex] = {
        ...newData[rowIndex],
        [column]: updatedValue,
      };

      // Call save method immediately after change
      handleSaveRow(newData[rowIndex]);

      return newData;
    });
  };

  const handleAddRow = () => {
    setShowAddDialog(true);
  };

  const handleSaveRow = async (rowData) => {
    setupdateLoader(true);
    const username = localStorage.getItem("username");

    const updatedRowData = {
      ...rowData,
      Username: username,
      Utfascii: rowData.Word,
    };

    // Find original row to compare changes
    const originalRow = originalData.find((item) => item.Id === rowData.Id);

    // 🔁 Check for duplicate word only if Word has changed
    const isWordChanged =
      originalRow &&
      originalRow.Word.trim().toLowerCase() !==
        updatedRowData.Word.trim().toLowerCase();

    if (isWordChanged) {
      const isDuplicate = data.some(
        (item) =>
          item.Id !== updatedRowData.Id &&
          item.Word.trim().toLowerCase() ===
            updatedRowData.Word.trim().toLowerCase()
      );

      if (isDuplicate) {
        Swal.fire({
          title: "Warning!",
          text: `Word "${updatedRowData.Word}" already exists.`,
          icon: "warning",
        });

        setupdateLoader(false);
        return;
      }
    }

    const selectedDate = new Date(updatedRowData.Date)
      .toISOString()
      .split("T")[0];

    const originalDate = originalRow
      ? new Date(originalRow.Date).toISOString().split("T")[0]
      : null;

    const isDuplicateDate =
      selectedDate !== originalDate &&
      data.some((item) => {
        const itemDate = new Date(item.Date).toISOString().split("T")[0];
        return item.Id !== updatedRowData.Id && itemDate === selectedDate;
      });

    if (isDuplicateDate) {
      Swal.fire({
        title: "Warning!",
        text: `This date already exists. Please choose another date.`,
        icon: "warning",
      });

      if (originalRow) {
        const revertedData = data.map((item) =>
          item.Id === rowData.Id ? { ...item, Word: originalRow.Word } : item
        );
        setData(revertedData);
      }

      setupdateLoader(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/Update",
        updatedRowData,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const modifiedField = await updateWord(updatedRowData);
      setupdateLoader(false);
      // Swal.fire({
      //   title: "Success",
      //   text: "Word updated successfully",
      //   icon: "success",
      // });
      console.log(updatedValues);
      // setSnackbarMessage(
      //   `Modified Type: ${modifiedField.ModifiedType}, ` +
      //     `Modified Value: ${modifiedField.ModifiedValue}, ` +
      //     `Modified By: ${modifiedField.Username}`
      // );
      setSnackbarMessage("Word updated Successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Update failed:", error);
      setupdateLoader(false);
      Swal.fire({
        title: "Error",
        text: "Failed to update word!",
        icon: "error",
      });
    }
  };

  const uploadVideoFile = async (file, username, word) => {
    console.log(word);
    const convertBase64ToMp4Blob = (base64String) => {
      const base64Data = base64String.split(",")[1];
      const byteCharacters = atob(base64Data);
      const byteArrays = [];

      for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
      }

      return new Blob([new Uint8Array(byteArrays)], { type: "video/mp4" });
    };

    const videoForm = new FormData();
    videoForm.append("word", word);
    videoForm.append("Username", username);

    if (file && typeof file === "string" && file.startsWith("data:")) {
      const videoBlob = convertBase64ToMp4Blob(file);
      videoForm.append("video", videoBlob);
    } else {
      videoForm.append("video", file); // This can be a File object
    }

    try {
      const response = await axios.post(
        "https://s3napi-dev.s3nsoftware.com/api/UserProfiles/UploadVideoFile",
        videoForm,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data; // Uploaded video URL
    } catch (error) {
      console.error("Video upload failed:", error);
      throw new Error("Video upload failed.");
    }
  };

  const uploadAudioFile = async (file, username, word) => {
    const formData = new FormData();
    formData.append("audio", file);
    formData.append("Username", username);
    formData.append("word", word);

    try {
      const response = await axios.post(
        "https://s3napi-dev.s3nsoftware.com/api/UserProfiles/UploadAaudioFile2",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data; // assuming it returns the audio URL
    } catch (error) {
      console.error("Audio upload failed:", error);
      throw new Error("Audio upload failed.");
    }
  };

  const handlePlay = (url) => {
    const actualUrl = url?.startsWith("sound://")
      ? url.replace("sound://", "https://s3nsoftware.com/")
      : url;
    if (audioRef.current && actualUrl) {
      audioRef.current.src = actualUrl;
      audioRef.current.load();
      audioRef.current
        .play()
        .catch((err) => console.error("Audio play error:", err));
    }
  };

  const handleSaveData = async (rowData) => {
    setupdateLoader(true);
    try {
      const username = localStorage.getItem("username");
      const word = rowData.Word;

      const convertBase64ToMp4Blob = (base64String) => {
        const base64Data = base64String.split(",")[1];
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let i = 0; i < byteCharacters.length; i++) {
          byteArrays.push(byteCharacters.charCodeAt(i));
        }

        return new Blob([new Uint8Array(byteArrays)], { type: "video/mp4" });
      };

      // AUDIO UPLOAD
      let audioUrl = rowData.Audio;
      if (audioUrl?.startsWith("data:")) {
        const base64Audio = audioUrl.split(",")[1];
        const audioType = audioUrl.split(",")[0].split(":")[1].split(";")[0];
        const audioBlob = new Blob(
          [new Uint8Array([...atob(base64Audio)].map((c) => c.charCodeAt(0)))],
          { type: audioType }
        );

        const audioForm = new FormData();
        audioForm.append("word", word);
        audioForm.append("Username", username);
        audioForm.append("audio", audioBlob);

        const audioUpload = await axios.post(
          "https://s3napi-dev.s3nsoftware.com/api/UserProfiles/UploadAaudioFile2",
          audioForm,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress((prev) => ({ ...prev, audio: percent }));
            },
          }
        );

        audioUrl = audioUpload.data;
        console.log("Audio uploaded:", audioUrl);
      }

      // VIDEO UPLOAD
      let videoUrl = rowData.Video;
      if (videoUrl?.startsWith("data:")) {
        const videoBlob = convertBase64ToMp4Blob(videoUrl);
        const videoForm = new FormData();
        videoForm.append("word", word);
        videoForm.append("Username", username);
        videoForm.append("video", videoBlob);

        const videoUpload = await axios.post(
          "https://s3napi-dev.s3nsoftware.com/api/UserProfiles/UploadVideoFile",
          videoForm,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress((prev) => ({ ...prev, video: percent }));
            },
          }
        );

        videoUrl = videoUpload.data;
        console.log("Video uploaded:", videoUrl);
      }

      // VIDEOV UPLOAD
      let videoVUrl = rowData.VideoV;
      if (videoVUrl?.startsWith("data:")) {
        const videoVBlob = convertBase64ToMp4Blob(videoVUrl);
        const videoVForm = new FormData();
        videoVForm.append("word", word);
        videoVForm.append("Username", username);
        videoVForm.append("video", videoVBlob);

        const videoVUpload = await axios.post(
          "https://s3napi-dev.s3nsoftware.com/api/UserProfiles/UploadVideoFile",
          videoVForm,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const percent = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress((prev) => ({ ...prev, videoV: percent }));
            },
          }
        );

        videoVUrl = videoVUpload.data;
        console.log("VideoV uploaded:", videoVUrl);
      }

      // FINAL SAVE
      const updatedRowData = {
        ...rowData,
        Audio: audioUrl,
        Video: videoUrl,
        VideoV: videoVUrl,
        Username: username,
        Utfascii: rowData.Word,
      };

      const response = await axios.post(
        "https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/AddNeW",
        updatedRowData
      );
      // setShowAddDialog(false)
      updateWord(response.data);
      setData((prev) => [...prev, response.data]); // this refreshes the table

      console.log("Saved:", response.data);
      // setupdateLoader(false);

      Swal.fire({
        title: "success",
        text: "Word saved successfully",
        icon: "success",
      });
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save word.");
      Swal.fire({
        title: "Error",
        text: "Failed to save word!",
        icon: "Error",
      });
    } finally {
      setShowAddDialog(false);
      setupdateLoader(false);
      setUploadProgress({ audio: 0, video: 0, videoV: 0 });
    }
  };
  const updateWord = async (updated_data) => {
    const now = new Date().toISOString();

    const oldEntry = originalData.find((item) => item.Id === updated_data.Id);

    if (!oldEntry) {
      // If entry not found, treat it as a new entry
      const modifiedField = {
        Id: updated_data.Id,
        Word: updated_data.Word,
        Username: updated_data.Username || "unknown",
        FirstInserted: now,
        ModifiedValue: "new",
        ModifiedType: "new",
        WordId: updated_data.Id,
      };

      console.log("Sending new entry:", modifiedField);

      try {
        const response = await fetch(
          "https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/UpdateWordlogs",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(modifiedField),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        setupdatedValues(JSON.stringify(modifiedField));
        console.log("New word log created successfully:", result);
        return modifiedField;
      } catch (error) {
        console.error("Error creating new word log:", error);
      }

      return;
    }

    // Entry exists – check for field modifications

    for (const key in updated_data) {
      if (
        key !== "FirstInserted" &&
        key !== "LastUpdated" &&
        key !== "Multichoices" &&
        updated_data[key] !== oldEntry[key]
      ) {
        const modifiedField = {
          Id: oldEntry.Id,
          Word: oldEntry.Word,
          Username: oldEntry.Username,
          FirstInserted: now,
          ModifiedValue: updated_data[key],
          ModifiedType: key,
          WordId: oldEntry.Id,
        };

        console.log("Sending change:", modifiedField);

        try {
          const response = await fetch(
            "https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/UpdateWordlogs",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(modifiedField),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const result = await response.json();

          console.log("Word log updated successfully:", result);
          setupdatedValues(modifiedField);
          return modifiedField;
        } catch (error) {
          console.error("Error updating word log:", error);
        }

        return;
      }
    }

    console.log("No field was modified.");
  };

  const handleWordIconClick = async (word) => {
    console.log(word);
    try {
      // Fetch logs from API
      const response = await fetch(
        `https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/WordUpdateHistory?Id=${word.Id}`
      );
      if (!response.ok) throw new Error("Failed to fetch logs");

      const data = await response.json();

      if (!data || data.length === 0) {
      // Handle empty case
      console.warn("No logs found for this word");
      setWordLogs([]); 
      //setShowLogsPopup(); // Still show popup, maybe with "No logs found"
      //setSnackbarMessage("No logs found for this word");

      Swal.fire({
        icon: "info",
        title: "No Logs Found",
        text: "There are no update logs available for this word.",
      });
    } else {
      setWordLogs(data);
      setShowLogsPopup(true);
    }

     // setWordLogs(data);
     // setShowLogsPopup(true); // Show popup
    } catch (error) {
      console.error("Error fetching word logs:", error);
    }
  };
  // ---- Your functions (unchanged) ----
  // const handleTermChange = (index, value) => {
  //   const updatedTerms = [...selectedTerms];
  //   updatedTerms[index] = value;
  //   setSelectedTerms(updatedTerms);
  // };

  const getQuizUrlByGradeIndex = (index) => {
    if (index === 0 || index === 1) return "/playquiz/56";
    if (index === 2 || index === 3) return "/playquiz/57";
    if (index >= 4 && index <= 7) return "/playquiz/58";
    return "/";
  };

  const getQuizPackMessage = (index) => {
    if (index === 0 || index === 1) return "(Dictionary 1 recommended)";
    if (index === 2) return "(Dictionary 2 recommended)";
    if (index === 3) return "(Dict 3 recommended)";
    if (index >= 4 && index <= 7) return "(Dictionary 4 and 5 recommended)";
    return "";
  };

  const togglePackVisibility = (packId) => {
    setExpandedPacks((prev) => ({
      ...prev,
      [packId]: !prev[packId],
    }));
  };

  const updateQuizId = (value) => {
    navigate(`/playquiz/${value}`);
  };

  const addToCart = (pack, type, price, isCollection, action, packname) => {
    updateShowCart(true);
    updateCart((prevCart) => {
      const currentCart = Array.isArray(prevCart) ? prevCart : [];
      if (action === "add") {
        const itemAlreadyInCart = currentCart.some(
          (item) =>
            item.packId === pack.Id && item.isCollection === isCollection
        );
        if (itemAlreadyInCart) {
          Swal.fire({
            title: "Info",
            text: "This item is already in your cart.",
            icon: "info",
          });
          return currentCart;
        }
        if (isCollection) {
          if (Array.isArray(pack.Categories)) {
            const categoryAlreadyInCart = currentCart.some((item) =>
              pack.Categories.some(
                (category) => item.packId === category.CollectionId
              )
            );
            if (categoryAlreadyInCart) {
              Swal.fire({
                title: "Alert",
                text: "Some categories from this collection are already in your cart. Please remove them first if you wish to add the entire collection.",
                icon: "warning",
              });
              return currentCart;
            }
            const updatedCart = currentCart.filter(
              (item) =>
                !pack.Categories.some(
                  (category) => item.packId === category.CollectionId
                )
            );
            const newCartItem = {
              pack,
              packId: pack.Id,
              type,
              price,
              isCollection,
              packname,
            };
            const newCart = [...updatedCart, newCartItem];
            localStorage.setItem("cart", JSON.stringify(newCart));
            return newCart;
          }
        } else {
          const collectionInCart = currentCart.some(
            (item) => item.packId === pack.CollectionId
          );
          if (collectionInCart) {
            Swal.fire({
              title: "Alert",
              text: "The collection containing this category is already in your cart. You cannot add individual categories from the collection.",
              icon: "warning",
            });
            return currentCart;
          }
          const newCartItem = {
            pack,
            packId: pack.Id,
            type,
            price,
            isCollection: false,
            packname,
          };
          const newCart = [...currentCart, newCartItem];
          localStorage.setItem("cart", JSON.stringify(newCart));
          return newCart;
        }
      } else if (action === "remove") {
        const updatedCart = currentCart.filter(
          (item) =>
            !(item.packId === pack.Id && item.isCollection === isCollection)
        );
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        return updatedCart;
      }
    });
  };

  const handleCheckout = () => {
    const loggedin = localStorage.getItem("loggedin");
    if (!loggedin || loggedin === "false") {
      Swal.fire({
        icon: "warning",
        text: "Please login or signup to subscribe",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Login",
        denyButtonText: "Sign Up",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          updateIsLoginOpen(true);
          updateIsSignUpOpen(false);
        } else if (result.isDenied) {
          updateIsSignUpOpen(true);
          updateIsLoginOpen(false);
        }
      });
      return;
    }
    setAmount(calculateTotal());
    setShowPaypalModel(true);
  };

  const deleteItem = (packId, type) => {
    updateCart((prevCart) => {
      const updatedCart = prevCart.filter(
        (item) => !(item.packId === packId && item.type === type)
      );
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;
    });
  };

  const toggleCartVisibility = () => {
    updateShowCart(!showCart);
  };

  const calculateTotal = () => {
    return cart.reduce((sum, item) => sum + item.price, 0).toFixed(2);
  };

  const updateQuizModel = (value) => {
    setOpenQuizModel(value);
  };

  const updateShowPaypalModel = (value) => {
    setShowPaypalModel(value);
  };

  const updateOpenAdd = (value) => {
    setIsOpenAdd(value);
  };
  const handleDelete = async (rowIndex, row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            "https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/Delete",
            {
              params: { Id: row.Id },
              headers: { Accept: "application/json" },
            }
          );
          console.log("Deleted:", response.data);

          setData((prev) => prev.filter((item) => item.Id !== row.Id));

          Swal.fire("Deleted!", "Record has been deleted.", "success");
        } catch (error) {
          console.error("Error deleting word:", error);
          Swal.fire("Error!", "Something went wrong while deleting.", "error");
        }
      }
    });
  };

  const [openQuizSelectionModel, setOpenQuizSelectionModel] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const openSelectionQuizModel =(row) =>{
    setSelectedRow(row);
    setOpenQuizSelectionModel(true);
  }

  const closeSelectionQuizModel =() =>{
    setOpenQuizSelectionModel(false);
  }

  return (
    <>
      {showCart && (
        <ShowCart
          showCart={showCart}
          toggleCartVisibility={toggleCartVisibility}
          cart={cart}
          deleteItem={deleteItem}
          handleCheckout={handleCheckout}
          calculateTotal={calculateTotal}
          filteredCart={filteredCart}
        />
      )}

      {openQuizModel && (
        <QuizzesModel
          open={openQuizModel}
          updateQuizModel={updateQuizModel}
          catId={catId}
          updateQuizId={updateQuizId}
          pack={pack}
        />
      )}

      <PayPalModal
        showPaypalModel={showPaypalModel}
        updateShowPaypalModel={updateShowPaypalModel}
        amount={amount}
        SelectedId={12}
        IsCollectionId={true}
        IsMonthly={true}
        Username={username}
        cartdata={cart}
        filteredCart={filteredCart}
      />
      <AdvertisementModel open={isOpenAdd} updateIsOpen={updateOpenAdd} />
      {loading ? (
        <>
          <Backdrop
            sx={{
              color: "#000",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={loading}
          >
            <div style={{ textAlign: "center" }}>
              <CircularProgress sx={{ color: "#007bff" }} />
              <p style={{ marginTop: "8px", fontWeight: "500" }}>Loading...</p>
              {uploadProgress.audio > 0 && (
                <p className="upload-progress audio-progress">
                  Audio: {uploadProgress.audio}%
                </p>
              )}
              {uploadProgress.video > 0 && (
                <p className="upload-progress video-progress">
                  Video: {uploadProgress.video}%
                </p>
              )}
              {uploadProgress.videoV > 0 && (
                <p className="upload-progress videoV-progress">
                  VideoV: {uploadProgress.videoV}%
                </p>
              )}
            </div>
          </Backdrop>
        </>
      ) : (
        <div className="tbcontainer">
          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={() => setOpenSnackbar(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={() => setOpenSnackbar(false)}
              severity={snackbarSeverity}
              sx={{ width: "100%" }}
              variant="filled"
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>

          <Backdrop
            sx={{
              color: "#000",
              backgroundColor: "rgba(255, 255, 255, 0.5)", // transparent white overlay
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={updateLoader}
          >
            <div style={{ textAlign: "center" }}>
              <CircularProgress sx={{ color: "#007bff" }} />
              <p style={{ marginTop: "8px", fontWeight: "500" }}>
                Updating..Please Wait
              </p>
              {uploadProgress.audio > 0 && (
                <p className="upload-progress audio-progress">
                  Audio: {uploadProgress.audio}%
                </p>
              )}
              {uploadProgress.video > 0 && (
                <p className="upload-progress video-progress">
                  Video: {uploadProgress.video}%
                </p>
              )}
              {uploadProgress.videoV > 0 && (
                <p className="upload-progress videoV-progress">
                  VideoV: {uploadProgress.videoV}%
                </p>
              )}
            </div>
          </Backdrop>
          <audio ref={audioRef} controls style={{ display: "none" }} />

          <div
            className="add-row-container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <button onClick={handleAddRow} className="btn add-row-btn">
              + Add New Word
            </button>

            <div style={{ position: "relative", width: 320 }}>
              <input
                type="text"
                placeholder="Search Word, Etym, Defn, Vocabulary, Pron, Pos…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  padding: "8px 10px",
                  width: "100%",
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  fontSize: "12px",
                }}
              />
              {searchTerm && (
                <span
                  onClick={() => setSearchTerm("")}
                  style={{
                    position: "absolute",
                    right: 8,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#888",
                    fontSize: "12px",
                  }}
                >
                  ✕
                </span>
              )}
            </div>
          </div>

          <div className="table-outer-wrapper">
            <div className="table-wrapper">
              <div className="table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      {desiredColumns.map((col) => {
                        const isSortable = col === "Word" || col === "Date";
                        const isActive = sortConfig.key === col;

                        return (
                          <th
                            key={col}
                            onClick={() =>
                              isSortable ? handleSort(col) : null
                            }
                            style={{
                              cursor: isSortable ? "pointer" : "default",
                              userSelect: "none",
                            }}
                          >
                            {col === "Date" ? "Release Date" : col}

                            {isSortable && (
                              <span style={{ marginLeft: "6px" }}>
                                {!isActive && (
                                  <FaSort style={{ color: "#ccc" }} />
                                )}
                                {isActive &&
                                  (sortConfig.direction === "asc" ? (
                                    <FaSortUp style={{ color: "white" }} />
                                  ) : (
                                    <FaSortDown style={{ color: "white" }} />
                                  ))}
                              </span>
                            )}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {sortedData.map((row, index) => {
                      const rowIndex = (currentPage - 1) * rowsPerPage + index;

                      return (
                        <tr
                          key={row.Id || rowIndex}
                          className={rowIndex % 2 === 0 ? "even-row" : ""}
                        >
                          {desiredColumns.map((col) => {
                            const key = `${rowIndex}-${col}`;
                            if (!cellRefs.current[key]) {
                              cellRefs.current[key] = React.createRef();
                            }

                            if (col === "Username") {
                              return (
                                <td
                                  key={col}
                                  style={{ color: "gray", fontStyle: "italic" }}
                                  title="This field is read-only."
                                >
                                  {row[col] || "-"}
                                </td>
                              );
                            }

                            if (scrollableColumns.includes(col)) {
                              return (
                                <td key={col} className="scrollable-cell-td">
                                  <div
                                    ref={cellRefs.current[key]}
                                    contentEditable
                                    suppressContentEditableWarning
                                    onBlur={(e) =>
                                      handleChange(e, rowIndex, col)
                                    }
                                    className={`scrollable-cell content-editable ${
                                      focusCell.rowIndex === rowIndex &&
                                      focusCell.column === col
                                        ? "blink"
                                        : ""
                                    }`}
                                  >
                                    {row[col]?.toString()}
                                  </div>
                                </td>
                              );
                            }

                            if (col === "Date") {
                              const valueIso = row[col]
                                ? String(row[col]).split("T")[0]
                                : "";
                              return (
                                <td key={col}>
                                  <RowDateCell
                                    valueIso={valueIso}
                                    minDate={new Date()}
                                    focus={
                                      focusCell.rowIndex === rowIndex &&
                                      focusCell.column === col
                                    }
                                    takenDateSet={takenDateSet}
                                    onChangeIso={(iso) =>
                                      handleChange(
                                        { target: { value: iso } },
                                        rowIndex,
                                        col
                                      )
                                    }
                                  />
                                </td>
                              );
                            }

                            if (col === "Word") {
                              return (
                                <td
                                  key={col}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <FaInfoCircle
                                    style={{
                                      marginRight: "5px",
                                      color: "#007bff",
                                      cursor: "pointer",
                                    }}
                                    title="View Word History"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                      handleWordIconClick(row);
                                    }}
                                  />
                                  <div
                                    ref={cellRefs.current[key]}
                                    contentEditable
                                    suppressContentEditableWarning
                                    onBlur={(e) =>
                                      handleChange(e, rowIndex, col)
                                    }
                                    className={`content-editable word-cell ${
                                      focusCell.rowIndex === rowIndex &&
                                      focusCell.column === col
                                        ? "blink"
                                        : ""
                                    }`}
                                  >
                                    {row[col]?.toString() || "-"}
                                  </div>
                                </td>
                              );
                            }

                            if (col === "Actions") {
                              return (
                                <td key={col} className="actions-cell">
                                  <button
                                    onClick={() => handleDelete(rowIndex, row)}
                                    className="btn btn-delete"
                                    title="Delete Row"
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                      cursor: "pointer",
                                      color: "red",
                                      fontSize: "16px",
                                    }}
                                  >
                                    <FaTrash />
                                  </button>
                                </td>
                              );
                            }

                            if(col === "Quiz") {
                              return (
                                <td key={col} className="quiz-cell">
                                  <button
                                    onClick={() => openSelectionQuizModel(row)}
                                    className="btn btn-quiz"
                                    title="Take Quiz"
                                  >
                                    Take Quiz
                                  </button>
                                  
                                </td>
                              )
                            }
                            return (
                              <td key={col}>
                                {col === "Quizlevel" ? (
                                  <select
                                    ref={cellRefs.current[key]}
                                    value={row[col] || ""}
                                    onChange={(e) =>
                                      handleChange(e, rowIndex, col)
                                    }
                                    className={`quizlevel-select ${
                                      focusCell.rowIndex === rowIndex &&
                                      focusCell.column === col
                                        ? "blink"
                                        : ""
                                    }`}
                                  >
                                    <option value="" disabled hidden>
                                      Quizlevel
                                    </option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                  </select>
                                ) : isMediaColumn(col) ? (
                                  <div className="media-cell">
                                    <button
                                      onClick={() =>
                                        isAudioColumn(col)
                                          ? handlePlay(row[col])
                                          : isVideoColumn(col)
                                          ? setVideoUrl(row[col])
                                          : row[col] &&
                                            window.open(row[col], "_blank")
                                      }
                                      disabled={!row[col]}
                                      className="btn btn-play"
                                      title="Play"
                                    >
                                      <FaPlay />
                                    </button>
                                    <button
                                      onClick={() =>
                                        isVideoColumn(col)
                                          ? setEditingVideo({
                                              url: row[col] || "",
                                              rowIndex,
                                              column: col,
                                              word: row.Word,
                                            })
                                          : isAudioColumn(col)
                                          ? setEditingAudio({
                                              url: row[col] || "",
                                              rowIndex,
                                              word: row.Word,
                                            })
                                          : setFocusCell({
                                              rowIndex,
                                              column: col,
                                            })
                                      }
                                      className="btn btn-edit"
                                      title="Edit"
                                    >
                                      <FaEdit />
                                    </button>
                                  </div>
                                ) : col === "Image" ? (
                                  <div className="media-cell">
                                    <button
                                      onClick={() =>
                                        row[col] && setImageUrl(row[col])
                                      }
                                      disabled={!row[col]}
                                      className="btn btn-view"
                                      title="View Image"
                                    >
                                      <FaEye />
                                    </button>
                                    <button
                                      onClick={() =>
                                        setEditingImage({
                                          url: row[col] || "",
                                          rowIndex,
                                        })
                                      }
                                      className="btn btn-edit"
                                      title="Edit Image"
                                    >
                                      <FaEdit />
                                    </button>
                                  </div>
                                ) : (
                                  <div
                                    ref={cellRefs.current[key]}
                                    contentEditable
                                    suppressContentEditableWarning
                                    onBlur={(e) =>
                                      handleChange(e, rowIndex, col)
                                    }
                                    className={`content-editable default-content ${
                                      focusCell.rowIndex === rowIndex &&
                                      focusCell.column === col
                                        ? "blink"
                                        : ""
                                    }`}
                                  >
                                    {row[col]?.toString() || "-"}
                                  </div>
                                )}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {showLogsPopup && (
            <div className="modal show" style={{ display: "block" }}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {wordLogs&& wordLogs.length>0 ? wordLogs[0].Word.toUpperCase() : ''}  Word History
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowLogsPopup(false)}
                    ></button>
                  </div>
                  <div
                    className="modal-body"
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          {/* <th>Id</th> */}
                          {/* <th>Word</th> */}
                          <th>Username</th>
                          <th>Modified Date</th>
                          <th>ModifiedValue</th>
                          <th>ModifiedType</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wordLogs && wordLogs.length > 0 ? (
                          wordLogs.map((log) => (
                            <tr key={log.Id}>
                              {/* <td>{log.Id}</td> */}
                              {/* <td>{log.Word}</td> */}
                              <td>{log.Username || "-"}</td>
                              <td>{log.FirstInserted}</td>
                              <td>{log.ModifiedValue}</td>
                              <td>{log.ModifiedType}</td>
                            </tr>
                          ))
                        ) : (
                          <div style={{ textAlign: "center", padding: "10px",justifyContent:'center' }}>
                            No history found for this word.
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="pagination-container">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="btn"
            >
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className="btn"
            >
              Next
            </button>
          </div>

          {videoUrl && (
            <div
              className="video-edit-dialog-overlay"
              onClick={() => setVideoUrl(null)}
            >
              {" "}
              <button
                className="video-dialog-close"
                onClick={() => setVideoUrl(null)}
              >
                <FaTimes />
              </button>
              <div
                className="video-edit-dialog"
                onClick={(e) => e.stopPropagation()}
              >
                <YouTubePlayer videoUrl={videoUrl} />
              </div>
            </div>
          )}

          {imageUrl && (
            <div
              className="image-dialog-overlay"
              onClick={() => setImageUrl(null)}
            >
              <div
                className="image-dialog"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="image-dialog-close"
                  onClick={() => setImageUrl(null)}
                >
                  <FaTimes />
                </button>
                <img src={imageUrl} alt="Preview" className="image-preview" />
              </div>
            </div>
          )}

          {editingImage.rowIndex !== null && (
            <div
              className="image-edit-dialog-overlay"
              onClick={() => setEditingImage({ url: "", rowIndex: null })}
            >
              <div
                className="image-edit-dialog"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="dialog-close"
                  onClick={() => setEditingImage({ url: "", rowIndex: null })}
                >
                  <FaTimes />
                </button>
                <h3>Edit Image</h3>
                <input
                  type="text"
                  value={editingImage.url}
                  onChange={(e) =>
                    setEditingImage((prev) => ({
                      ...prev,
                      url: e.target.value,
                    }))
                  }
                  className="media-input"
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        setEditingImage((prev) => ({
                          ...prev,
                          url: reader.result,
                        }));
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />
                {editingImage.url && (
                  <div className="image-preview-container">
                    <img
                      src={editingImage.url}
                      alt="Preview"
                      className="image-preview"
                    />
                  </div>
                )}
                <button
                  className="btn btn-save"
                  onClick={() => {
                    const updated = [...data];
                    updated[editingImage.rowIndex]["Image"] = editingImage.url;
                    setData(updated);
                    handleSaveRow(updated[editingImage.rowIndex]); // call API
                    setEditingImage({ url: "", rowIndex: null });
                  }}
                >
                  <FaSave /> Save
                </button>
              </div>
            </div>
          )}

          {editingVideo.rowIndex !== null && (
            <div
              className="video-edit-dialog-overlay"
              onClick={() =>
                setEditingVideo({
                  url: "",
                  rowIndex: null,
                  column: "",
                  word: "",
                })
              }
            >
              <div
                className="video-edit-dialog"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="dialog-close"
                  onClick={() =>
                    setEditingVideo({
                      url: "",
                      rowIndex: null,
                      column: "",
                      word: "",
                    })
                  }
                >
                  <FaTimes />
                </button>
                <h3>Edit {editingVideo.column}</h3>
                {editingVideo.url && (
                  <div className="video-preview-container">
                    {editingVideo.url.includes("youtube.com") ||
                    editingVideo.url.includes("youtu.be") ? (
                      <iframe
                        width="80%"
                        height="80%"
                        src={`https://www.youtube.com/embed/${
                          editingVideo.url
                            .replace("https://www.youtube.com/watch?v=", "")
                            .replace("https://youtu.be/", "")
                            .split("&")[0]
                        }`}
                        title="YouTube video preview"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <video
                        src={
                          editingVideo.url.startsWith("sound://")
                            ? editingVideo.url.replace(
                                "sound://",
                                "https://s3nsoftware.com/"
                              )
                            : editingVideo.url
                        }
                        controls
                        width="80%"
                        height="80%"
                        className="video-preview"
                      />
                    )}
                  </div>
                )}
                <input
                  type="text"
                  value={editingVideo.url}
                  onChange={(e) =>
                    setEditingVideo((prev) => ({
                      ...prev,
                      url: e.target.value,
                    }))
                  }
                  className="media-input"
                />
                <input
                  type="file"
                  accept="video/*"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (file) {
                      try {
                        const username = localStorage.getItem("username");
                        const word = editingVideo.word;
                        console.log(editingVideo);
                        const uploadedUrl = await uploadVideoFile(
                          file,
                          username,
                          word
                        );

                        // Update video URL in editing state
                        setEditingVideo((prev) => ({
                          ...prev,
                          url: uploadedUrl,
                        }));
                      } catch (err) {
                        console.error("Upload error:", err);
                        setSnackbarMessage("Video upload failed.");
                        setSnackbarOpen(true);
                      }
                    }
                  }}
                />

                <VideoRecorder
                  onRecordingComplete={async (videoBlob) => {
                    try {
                      const username = localStorage.getItem("username");
                      const word = editingVideo.word;

                      const videoFile = new File(
                        [videoBlob],
                        "recorded-video.mp4",
                        {
                          type: "video/mp4",
                        }
                      );

                      const uploadedUrl = await uploadVideoFile(
                        videoFile,
                        username,
                        word
                      );

                      setEditingVideo((prev) => ({
                        ...prev,
                        url: uploadedUrl,
                      }));
                    } catch (err) {
                      console.error("Upload error:", err);
                      setSnackbarMessage("Video upload failed.");
                      setSnackbarOpen(true);
                    }
                  }}
                />

                <button
                  className="btn btn-save"
                  onClick={() => {
                    const updated = [...data];
                    updated[editingVideo.rowIndex][editingVideo.column] =
                      editingVideo.url;
                    setData(updated);
                    handleSaveRow(updated[editingVideo.rowIndex]); // call API
                    setEditingVideo({
                      url: "",
                      rowIndex: null,
                      column: "",
                      word: "",
                    });
                  }}
                >
                  <FaSave /> Save
                </button>
              </div>
            </div>
          )}

          {editingAudio.rowIndex !== null && (
            <div
              className="video-edit-dialog-overlay"
              onClick={() =>
                setEditingAudio({ url: "", rowIndex: null, word: "" })
              }
            >
              <div
                className="video-edit-dialog"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="dialog-close"
                  onClick={() =>
                    setEditingAudio({ url: "", rowIndex: null, word: "" })
                  }
                >
                  <FaTimes />
                </button>
                <h3>Edit Audio</h3>
                <input
                  type="text"
                  value={editingAudio.url}
                  onChange={(e) =>
                    setEditingAudio((prev) => ({
                      ...prev,
                      url: e.target.value,
                    }))
                  }
                  className="media-input"
                  placeholder="Enter audio URL or name"
                />
                <input
                  type="file"
                  accept="audio/*"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    const username = localStorage.getItem("username");
                    const word = editingAudio.word;
                    if (file) {
                      try {
                        const uploadedUrl = await uploadAudioFile(
                          file,
                          username,
                          word
                        ); // Step 1
                        setEditingAudio((prev) => ({
                          ...prev,
                          url: uploadedUrl, // Set the hosted URL, not base64
                        }));
                      } catch (err) {
                        setSnackbarMessage("Audio upload failed.");
                        setSnackbarOpen(true);
                      }
                    }
                  }}
                />

                <button
                  className="btn btn-save"
                  onClick={() => {
                    if (!editingAudio.url || editingAudio.url.trim() === "") {
                      setSnackbarMessage(
                        "Audio is required. Please upload or enter a valid audio URL."
                      );
                      setSnackbarOpen(true);
                      return;
                    }

                    const updated = [...data];
                    updated[editingAudio.rowIndex]["Audio"] = editingAudio.url;
                    setData(updated);
                    handleSaveRow(updated[editingAudio.rowIndex]); // call API
                    setEditingAudio({ url: "", rowIndex: null, word: "" });
                  }}
                >
                  <FaSave /> Save
                </button>
              </div>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                  onClose={() => setSnackbarOpen(false)}
                  severity="error"
                  sx={{ width: "100%" }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
            </div>
          )}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={() => setSnackbarOpen(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
          {/* {showAddDialog && ( */}
          <Dialog
            open={showAddDialog}
            onClose={() => setShowAddDialog(false)}
            maxWidth="md"
            fullWidth
          >
            <Backdrop
              sx={{
                color: "#000",
                backgroundColor: "rgba(255, 255, 255, 0.5)", // transparent white overlay
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={updateLoader}
            >
              <div style={{ textAlign: "center" }}>
                <CircularProgress sx={{ color: "#007bff" }} />
                <p style={{ marginTop: "8px", fontWeight: "500" }}>
                  Updating..Please Wait
                </p>
                {uploadProgress.audio > 0 && (
                  <p className="upload-progress audio-progress">
                    Audio: {uploadProgress.audio}%
                  </p>
                )}
                {uploadProgress.video > 0 && (
                  <p className="upload-progress video-progress">
                    Video: {uploadProgress.video}%
                  </p>
                )}
                {uploadProgress.videoV > 0 && (
                  <p className="upload-progress videoV-progress">
                    VideoV: {uploadProgress.videoV}%
                  </p>
                )}
              </div>
            </Backdrop>
            <div style={{ padding: "20px" }}>
              <button
                className="dialog-close"
                onClick={() => setShowAddDialog(false)}
              >
                <FaTimes />
              </button>
              <h3>Add New Word</h3>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Word"
                      size="small"
                      value={newRowData.Word}
                      onChange={(e) =>
                        setNewRowData({ ...newRowData, Word: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Etym"
                      value={newRowData.Etym}
                      onChange={(e) =>
                        setNewRowData({ ...newRowData, Etym: e.target.value })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Definition"
                      value={newRowData.Defn}
                      onChange={(e) =>
                        setNewRowData({ ...newRowData, Defn: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Vocabulary"
                      value={newRowData.Vocabulary}
                      onChange={(e) =>
                        setNewRowData({
                          ...newRowData,
                          Vocabulary: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Pronunciation"
                      value={newRowData.Pron}
                      onChange={(e) =>
                        setNewRowData({ ...newRowData, Pron: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Parts of speech"
                      value={newRowData.Pos}
                      onChange={(e) =>
                        setNewRowData({ ...newRowData, Pos: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <label
                        htmlFor="my-datepicker"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Date
                      </label>
                      <DatePicker
                        id="my-datepicker"
                        selected={
                          newRowData.Date ? fromISO(newRowData.Date) : null
                        }
                        onChange={(date) =>
                          setNewRowData({
                            ...newRowData,
                            Date: date ? toLocalISO(date) : "",
                          })
                        }
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        minDate={new Date()}
                        filterDate={(d) => !takenDateSet.has(toLocalISO(d))}
                        placeholderText="yyyy-MM-dd"
                      />
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ mb: 2 }}>
                  {/* Quiz Level block kept commented as in your code */}
                </Grid>
              </Box>

              {/* Image */}
              <div
                style={{
                  border: "2px solid #ccc",
                  borderRadius: "12px",
                  padding: "16px",
                  marginTop: "16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                <Grid container spacing={2} className="form-group">
                  <Grid item xs={5}>
                    <TextField
                      fullWidth
                      placeholder="Enter Image URL"
                      value={newRowData.Image}
                      onChange={(e) =>
                        setNewRowData({ ...newRowData, Image: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <p style={{ textAlign: "center", marginTop: "8px" }}>OR</p>
                  </Grid>
                  <Grid item xs={5}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setNewRowData((prev) => ({
                              ...prev,
                              Image: reader.result,
                            }));
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </div>

              {/* Audio */}
              <div
                style={{
                  border: "2px solid #ccc",
                  borderRadius: "12px",
                  padding: "16px",
                  marginTop: "16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                <Grid container spacing={2} className="form-group">
                  <Grid item xs={5}>
                    <TextField
                      fullWidth
                      placeholder="Enter Audio URL"
                      value={newRowData.Audio}
                      onChange={(e) =>
                        setNewRowData({ ...newRowData, Audio: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <p style={{ textAlign: "center", marginTop: "8px" }}>OR</p>
                  </Grid>
                  <Grid item xs={5}>
                    <input
                      type="file"
                      accept="audio/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setNewRowData((prev) => ({
                              ...prev,
                              Audio: reader.result,
                            }));
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </div>

              {/* Video */}
              <AccordionDetails>
                <div
                  style={{
                    border: "2px solid #ccc",
                    borderRadius: "12px",
                    padding: "16px",
                    marginTop: "16px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <Grid container spacing={2} className="form-group">
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        placeholder="Enter Video URL"
                        value={newRowData.Video}
                        onChange={(e) =>
                          setNewRowData({
                            ...newRowData,
                            Video: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <p style={{ textAlign: "center", marginTop: "8px" }}>
                        OR
                      </p>
                    </Grid>
                    <Grid item xs={4}>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                              setNewRowData((prev) => ({
                                ...prev,
                                Video: reader.result,
                              }));
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <p style={{ textAlign: "center", marginTop: "8px" }}>
                        OR
                      </p>
                    </Grid>
                    <Grid item xs={4}>
                      <VideoRecorder
                        onRecordingComplete={(videoBlob) => {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setNewRowData((prev) => ({
                              ...prev,
                              Video: reader.result, // base64 format from blob
                            }));
                          };
                          reader.readAsDataURL(videoBlob);
                        }}
                      />
                    </Grid>
                  </Grid>

                  {/* ✅ Video Preview */}
                  {newRowData.Video && (
                    <div style={{ marginTop: "20px" }}>
                      <Typography variant="subtitle1" gutterBottom>
                        Preview:
                      </Typography>
                      <video
                        controls
                        width="50%"
                        style={{ maxHeight: "360px", borderRadius: "8px" }}
                      >
                        <source
                          src={newRowData.Video}
                          type={
                            newRowData.Video.startsWith("data:")
                              ? "video/mp4"
                              : undefined
                          }
                        />
                        Your browser does not support the video tag.
                      </video>
                      <button
                        className="btn btn-danger"
                        style={{ marginTop: "10px" }}
                        onClick={() =>
                          setNewRowData((prev) => ({
                            ...prev,
                            Video: "",
                          }))
                        }
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
              </AccordionDetails>

              {/* VideoV */}
              <div style={{ marginTop: "10px" }}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreOutlined />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography component="span">VideoV</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div
                      style={{
                        border: "2px solid #ccc",
                        borderRadius: "12px",
                        padding: "16px",
                        marginTop: "16px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Grid container spacing={2} className="form-group">
                        <Grid item xs={5}>
                          <TextField
                            fullWidth
                            placeholder="Enter VideoV URL"
                            value={newRowData.VideoV}
                            onChange={(e) =>
                              setNewRowData({
                                ...newRowData,
                                VideoV: e.target.value,
                              })
                            }
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <p style={{ textAlign: "center", marginTop: "8px" }}>
                            OR
                          </p>
                        </Grid>
                        <Grid item xs={5}>
                          <input
                            type="file"
                            accept="video/*"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  setNewRowData((prev) => ({
                                    ...prev,
                                    VideoV: reader.result,
                                  }));
                                };
                                reader.readAsDataURL(file);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <p style={{ textAlign: "center", marginTop: "8px" }}>
                            OR
                          </p>
                        </Grid>
                        <Grid item xs={4}>
                          <VideoRecorder
                            onRecordingComplete={(videoBlob) => {
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                setNewRowData((prev) => ({
                                  ...prev,
                                  VideoV: reader.result, // base64 format from blob
                                }));
                              };
                              reader.readAsDataURL(videoBlob);
                            }}
                          />
                        </Grid>
                      </Grid>
                      {newRowData.VideoV && (
                        <div style={{ marginTop: "20px" }}>
                          <Typography variant="subtitle1" gutterBottom>
                            Preview:
                          </Typography>
                          <video
                            controls
                            width="50%"
                            style={{ maxHeight: "360px", borderRadius: "8px" }}
                          >
                            <source
                              src={newRowData.VideoV}
                              type={
                                newRowData.VideoV.startsWith("data:")
                                  ? "video/mp4"
                                  : undefined
                              }
                            />
                            Your browser does not support the video tag.
                          </video>
                          <button
                            className="btn btn-danger"
                            style={{ marginTop: "10px" }}
                            onClick={() =>
                              setNewRowData((prev) => ({
                                ...prev,
                                VideoV: "",
                              }))
                            }
                          >
                            X
                          </button>
                        </div>
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
              {/* Save Button */}
              <button
                className="btn btn-save"
                onClick={async () => {
                  const isDuplicate = data.some(
                    (item) =>
                      item.Word.trim().toLowerCase() ===
                      newRowData.Word.trim().toLowerCase()
                  );

                  if (isDuplicate) {
                    setSnackbarMessage(
                      `Word "${newRowData.Word}" already exists.`
                    );
                    setSnackbarOpen(true);
                    return;
                  }
                  const validationError = validateNewWordData(newRowData);
                  if (validationError) {
                    setSnackbarMessage(validationError);
                    setSnackbarOpen(true);
                    return;
                  }

                  if (!newRowData.Audio || newRowData.Audio.trim() === "") {
                    setSnackbarMessage(
                      "Audio is required. Please upload an audio file or enter a valid URL."
                    );
                    setSnackbarOpen(true);
                    return;
                  }

                  if (!newRowData.Date || isNaN(new Date(newRowData.Date))) {
                    setSnackbarMessage("Please select a valid date.");
                    setSnackbarOpen(true);
                    setLoading(false);
                    return;
                  }

                  const selectedDate = new Date(newRowData.Date)
                    .toISOString()
                    .split("T")[0];

                  const isDuplicateDate = data.some((item) => {
                    const itemDate = new Date(item.Date)
                      .toISOString()
                      .split("T")[0];
                    return itemDate === selectedDate;
                  });

                  if (isDuplicateDate) {
                    setSnackbarMessage(
                      "This date already exists. Please choose another date."
                    );
                    setSnackbarOpen(true);
                    setLoading(false);
                    return;
                  }

                  const updatedData = [...data, newRowData];
                  // setData(updatedData);
                  await handleSaveData(newRowData);
                  setShowAddDialog(false);
                  setNewRowData({
                    Word: "",
                    Meaning: "",
                    Image: "",
                    Audio: "",
                    Video: "",
                    VideoV: "",
                    Quizlevel: "",
                    Date: "",
                    Etym: "",
                    Defn: "",
                    Vocabulary: "",
                    Pron: "",
                    Pos: "",
                  });
                }}
              >
                <FaSave /> Save
              </button>
            </div>
          </Dialog>
        </div>
      )}

      {openQuizSelectionModel && (
        <QuizSelectionModel
          open={openQuizSelectionModel}
          onClose={() => setOpenQuizSelectionModel(false)}
          selectedRow={selectedRow}
        />
      )}
    </>
  );
};

export default TableData;
